import { Paddle } from '@paddle/paddle-js';
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

import { ContentCard, Stack } from 'apps/dashboard/shared/scripts/components';
import { useUser } from 'apps/shared/scripts/graphql';

import { PLAN_TYPES } from '../../constants';
import CheckoutLoading from '../CheckoutLoading';
import CheckoutSuccess from '../CheckoutSuccess';
import CheckoutSummary from '../CheckoutSummary';

interface Props {
  cardId: string;
  paddle?: Paddle;
  isLoading?: boolean;
  isSuccess?: boolean;
  invoiceId?: string;
}

const CheckoutForm = ({
  cardId,
  paddle,
  isLoading,
  isSuccess,
  invoiceId,
}: Props) => {
  const { user } = useUser();

  useEffect(() => {
    const load = () => {
      paddle?.Checkout.open({
        settings: {
          displayMode: 'inline',
          frameTarget: 'checkout-container',
          frameInitialHeight: 450,
          frameStyle:
            'width: 100%; min-width: 312px; background-color: transparent; border: none;',
        },
        items: [{ priceId: PLAN_TYPES.Pro, quantity: 1 }],
        customData: {
          // IMPORTANT: custom data used for validation on server-side
          card_id: cardId,
          user_id: user!.id,
        },
      });
    };
    if (user) {
      load();
    }
  }, [cardId, paddle?.Checkout, user]);

  return (
    <Row>
      <Col lg={{ span: 5, order: 'last' }}>
        <Stack minimal>
          <CheckoutSummary />
        </Stack>
      </Col>
      <Col lg={{ span: 7, order: 'first' }}>
        <Stack>
          <ContentCard>
            {isLoading && <CheckoutLoading />}
            {isSuccess ? (
              <CheckoutSuccess cardId={cardId} invoiceId={invoiceId!} />
            ) : (
              <div
                id="checkout-container"
                className="checkout-container"
                style={{ margin: '-8px' }}
              />
            )}
          </ContentCard>
        </Stack>
      </Col>
    </Row>
  );
};

CheckoutForm.displayName = 'CheckoutForm';

export default CheckoutForm;
